import {merge} from 'lodash-es';
import {BaseOctopusConfig} from '../../../../base.octopus-config';
import {defaultApiURL} from '../../../../src/app/settings/amazon_python';

const overrideConfig = {
    configuration: {
        http: {
            apiUrl: defaultApiURL,
        }
    },
    map: {
        'lessons/requirements': {
            type: 'http',
            useLanguage: true,
        },
        'iackathon': 'http'
    }
};

export const CitizenCodeOctopusConfig = merge({}, BaseOctopusConfig, overrideConfig);